import React from 'react';

const ComplaintIcon = () => {
      return (
            <>
                  <span className="material-symbols-outlined">headset_mic</span>
            </>
      );
};

export default ComplaintIcon;
